import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Anchor, Instagram, Mail, MessageCircle } from 'lucide-react';
import { Button } from './ui';
const socials = [{
  name: 'WhatsApp',
  href: '#',
  Icon: MessageCircle
}, {
  name: 'Instagram',
  href: '#',
  Icon: Instagram
}, {
  name: 'Email',
  href: 'mailto:info@buceoynavegacion.com',
  Icon: Mail
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-noronha-volcanic/90 backdrop-blur-md border-b border-noronha-petroleum/30 py-4' : 'bg-transparent py-7'}`} data-id="element-220">
      <div className="container mx-auto px-6 flex items-start justify-between gap-4" data-id="element-221">
        {/* Brand block */}
        <a href="#" className="flex flex-col group" data-id="element-222">
          <AnimatePresence mode="wait" data-id="element-223">
            {isScrolled ? <motion.div key="condensed" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} className="flex items-center gap-2" data-id="element-224">
                <Anchor className="w-5 h-5 text-noronha-emerald" data-id="element-225" />
                <span className="font-heading font-bold text-base sm:text-lg tracking-[0.15em] text-noronha-text-heading uppercase" data-id="element-226">
                  Buceo y Navegación
                </span>
              </motion.div> : <motion.div key="full" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} data-id="element-227">
                <h2 className="font-heading font-bold text-xl sm:text-2xl md:text-3xl leading-[1.05] tracking-[0.12em] text-noronha-text-heading uppercase" data-id="element-228">
                  Buceo y
                  <br data-id="element-229" />
                  Navegación
                </h2>
                <div className="mt-3 flex flex-col gap-0.5 font-mono text-[10px] sm:text-xs tracking-[0.18em] text-noronha-emerald uppercase" data-id="element-230">
                  <span data-id="element-231">Escuela de Buceo</span>
                  <span data-id="element-232">Viajes Grupales</span>
                  <span data-id="element-233">Agencia de Turismo HC 26.614</span>
                </div>
              </motion.div>}
          </AnimatePresence>
        </a>

        {/* Socials + CTA */}
        <div className="flex flex-col items-end gap-4 shrink-0" data-id="element-234">
          <div className="flex items-center gap-3" data-id="element-235">
            {socials.map(({
            name,
            href,
            Icon
          }) => <a key={name} href={href} aria-label={name} className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center rounded-full border border-noronha-petroleum/60 text-noronha-text-heading hover:border-noronha-emerald hover:text-noronha-emerald hover:bg-noronha-emerald/10 transition-all duration-300" data-id="element-236">
                <Icon className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={1.75} data-id="element-237" />
              </a>)}
          </div>
          <Button variant="primary" className="hidden sm:inline-flex py-2.5 px-5 text-xs" data-id="element-238">
            Reservar mi lugar
          </Button>
        </div>
      </div>
    </header>;
}
export function Footer() {
  return <footer className="bg-noronha-graphite border-t border-noronha-petroleum/30 pt-20 pb-10" data-id="element-239">
      <div className="container mx-auto px-6" data-id="element-240">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-241">
          <div className="md:col-span-2" data-id="element-242">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-243">
              <Anchor className="w-6 h-6 text-noronha-emerald" data-id="element-244" />
              <span className="font-heading font-semibold text-xl text-noronha-text-heading" data-id="element-245">
                Buceo y Navegación
              </span>
            </a>
            <p className="text-noronha-text-body max-w-sm" data-id="element-246">
              Expediciones de buceo premium en los destinos más exclusivos del
              planeta. Naturaleza, aventura y excelencia.
            </p>
          </div>
          <div data-id="element-247">
            <h4 className="font-mono text-sm tracking-widest text-noronha-gold mb-6 uppercase" data-id="element-248">
              Destinos
            </h4>
            <ul className="flex flex-col gap-3 text-noronha-text-body" data-id="element-249">
              <li data-id="element-250">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-251">
                  Bonaire
                </a>
              </li>
              <li data-id="element-252">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-253">
                  Fernando de Noronha
                </a>
              </li>
              <li data-id="element-254">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-255">
                  Galápagos
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-256">
            <h4 className="font-mono text-sm tracking-widest text-noronha-gold mb-6 uppercase" data-id="element-257">
              Contacto
            </h4>
            <ul className="flex flex-col gap-3 text-noronha-text-body" data-id="element-258">
              <li data-id="element-259">
                <a href="mailto:info@buceoynavegacion.com" className="hover:text-noronha-emerald transition-colors" data-id="element-260">
                  info@buceoynavegacion.com
                </a>
              </li>
              <li data-id="element-261">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-262">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-263">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-264">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-noronha-petroleum/30 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-noronha-text-body/60" data-id="element-265">
          <p data-id="element-266">
            © {new Date().getFullYear()} Buceo y Navegación. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-267">
            <a href="#" className="hover:text-noronha-text-heading transition-colors" data-id="element-268">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-noronha-text-heading transition-colors" data-id="element-269">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-noronha-volcanic text-noronha-text-body font-sans selection:bg-noronha-emerald/30 selection:text-noronha-text-heading" data-id="element-270">
      <Navbar data-id="element-271" />
      <main data-id="element-272">{children}</main>
      <Footer data-id="element-273" />
    </div>;
}